import { computed, inject, Injectable, makeStateKey, signal, TransferState, } from '@angular/core';
import moment from 'moment';
import { FirebaseFirestore } from '../../app.config'
import { Alert } from '../model/alert.model';
import { CenterService } from './center.service';

@Injectable({
  providedIn: 'root',
})
/**
 * Alert Service
 */
export class AlertService {
  centerService = inject(CenterService);
  alerts = signal<Alert[]>([]);
  alert = computed<Alert | null>(() => {
    const currentCenter = this.centerService.center();
    const alerts = this.alerts();

    if (!currentCenter) {
      return null
    }

    const now = moment(new Date());
    return alerts.find(a => {
      if (!a.centers.includes(currentCenter.id)) {
        return false;
      }
      if (a.from && now.isBefore(moment(a.from))) {
        return false
      }
      if (a.to && now.isAfter(moment(a.to))) {
        return false
      }
      return a;
    }) ?? null;
  })
  private readonly alertsStateKey = makeStateKey<Alert[]>('ALERTS');
  private transferState = inject(TransferState);
  private firestore = inject(FirebaseFirestore);

  /**
   * Load alerts from bundle
   * @returns A Promise
   */
  async init(): Promise<void> {
    let alerts: Alert[];
    if (this.transferState.hasKey(this.alertsStateKey)) {
      alerts = this.transferState.get(this.alertsStateKey, []).map(p => new Alert(p));
    } else {
      alerts = await this.firestore.getDocs('alert', Alert);
      alerts.sort((a, b) => a.index - b.index)
      this.transferState.set(this.alertsStateKey, alerts);
    }
    this.alerts.set(alerts);
  }
}
